import { Publicacoes } from './publicacoes';
import { Materia } from './materia';
export class PublicaPort {
  idPublicaPort: number = null;
  dataBi: Date = null;
  dataDo: Date = null;
  dtConfirmacao: Date = null;
  //idMateria: number = null;
  //idDoc: number = null;
  materia: Materia = null;
  publicacoes: Publicacoes = null;
  localPubDo: string = null;
  nmCaderno: string = null;
  nomeUsu: string = null;
  dtDejtAvulso: Date = null;

  constructor(d?) {
    this.idPublicaPort = d.idPublicaPort ? d.idPublicaPort : null;
    this.nomeUsu = d.nomeUsu ? d.nomeUsu : null;
    //this.idMateria = d.idMateria ? d.idMateria : null;
    //this.idDoc = d.idDoc ? d.idDoc : null;
    this.publicacoes = d.publicacoes ? new Publicacoes(d.publicacoes) : null;
    this.materia = d.materia ? new Materia(d.materia) : null;
    this.dataBi = d.dataBi ? d.dataBi : null;
    this.dataDo = d.dataDo ? d.dataDo : null;
    this.localPubDo = d.localPubDo ? d.localPubDo : null;
    this.dtConfirmacao = d.dtConfirmacao ? d.dtConfirmacao : null;
    this.nmCaderno = d.nmCaderno ? d.nmCaderno : null;
    this.dtDejtAvulso = d.dtDejtAvulso ? d.dtDejtAvulso : null;
  }
}
